<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Agent</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%" v-if="editItem">
      <v-form ref="editAgentForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md4>
                <v-text-field
                  outline
                  label="Full Name *"
                  required
                  v-model="editItem.name"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Father's Name *"
                  required
                  v-model="editItem.father_name"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Mother's Name"
                  v-model="editItem.mother_name"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12> Present Address: </v-flex>
          <v-flex xs12>
            <v-layout>
              <v-flex md3>
                <v-autocomplete
                  label="District *"
                  v-model="editItem.present_district"
                  :items="districtTV()"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="PS *"
                  v-model="editItem.present_upazila"
                  :items="upazilaTV(editItem.present_district)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="P.O *"
                  v-model="editItem.present_union"
                  :items="unionTV(editItem.present_upazila)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-text-field
                  outline
                  label="Vill *"
                  required
                  v-model="editItem.present_village"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12> Permanent Address: </v-flex>
          <v-flex xs12>
            <v-layout pb-1>
              <v-flex md3>
                <v-autocomplete
                  label="District"
                  v-model="editItem.permanent_district"
                  :items="districtTV()"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="PS"
                  v-model="editItem.permanent_upazila"
                  :items="upazilaTV(editItem.permanent_district)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="P.O"
                  v-model="editItem.permanent_union"
                  :items="unionTV(editItem.permanent_upazila)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-text-field
                  outline
                  label="Vill"
                  v-model="editItem.permanent_village"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md6 class="pr-1">
                <v-menu
                  v-model="dobDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editItem.dob"
                      label="Date of birth"
                      readonly
                      outline
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editItem.dob"
                    @input="dobDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-text-field outline label="Age" v-model="editItem.age"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md6 class="pr-1">
                <v-text-field
                  outline
                  label="NID Number *"
                  v-model="editItem.nid_number"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  label="Nationality *"
                  v-model="editItem.nationality"
                  :items="NATIONALITIES"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap pb-4>
              <v-flex md6 pr-1>
                <v-autocomplete
                  label="Gender *"
                  v-model="editItem.gender"
                  :items="GENDERS"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  label="Religion *"
                  v-model="editItem.religion"
                  :items="getTV(RELIGIONS)"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md4>
                <v-text-field
                  outline
                  label="Mobile Number *"
                  v-model="editItem.mobile"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Emergency Contact *"
                  v-model="editItem.emergency_contact"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Relation *"
                  v-model="editItem.emergency_relation"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md4>
                <v-text-field
                  outline
                  label="Office/Comapny name"
                  v-model="editItem.company_name"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Staff Mobile No"
                  v-model="editItem.company_staff_contact"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Email"
                  v-model="editItem.email"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex xs -->
          <v-textarea v-model="editItem.notes" outline label="Notes"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Update</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { GENDERS, NATIONALITIES, RELIGIONS } from "../../mdsir/const";
import { getTV, districtTV, upazilaTV, unionTV } from "../../mdsir/MdsirUtils";

export default {
  props: ["editItem"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      dobDateMenu: false,
      NATIONALITIES: NATIONALITIES,
      RELIGIONS: RELIGIONS,
      GENDERS: GENDERS,
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.editAgentForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.editAgentForm.reset();
    },
    resetValidation() {
      this.$refs.editAgentForm.resetValidation();
    },
    // clearForm() {
    //   this.newItem.full_name = "";
    //   this.newItem.age = "";
    //   this.newItem.phone = "";
    //   this.newItem.notes = "";
    // },
    editItemDo() {
      if (this.$refs.editAgentForm.validate()) {
        this.actionButtonClicked = true;
        this.put("/agent", this.editItem).then((res) => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
  },
  mounted() {},
  created() {
    // this.GENDERS = GENDERS;
  },
};
</script>